
import wx from 'weixin-js-sdk'
/**
 * 检测当前环境
 */
function detectEnvironment() {
  console.log('[Platform] 开始检测环境...');

  const params = new URLSearchParams(window.location.search);
  const platformParam = params.get('platform');
  console.log('[Platform] URL 参数 platform:', platformParam);

  if (platformParam === 'app') {
    console.log('[Platform] ✅ 检测到 App 环境');
    return 'app';
  }
  if (platformParam === 'miniprogram') {
    console.log('[Platform] ✅ 检测到小程序环境');
    return 'miniprogram';
  }

  const ua = navigator.userAgent.toLowerCase();
  console.log('[Platform] UserAgent:', ua);

  if (ua.includes('miniprogram')) {
    console.log('[Platform] ✅ UserAgent 检测到小程序');
    return 'miniprogram';
  }

  if (window.ReactNativeWebView) {
    console.log('[Platform] ✅ 检测到 JSBridge (App)');
    return 'app';
  }

  console.log('[Platform] ✅ 默认 H5 环境');
  return 'h5';
}

/**
 * 判断是否为 WebView 环境
 */
export function isWebView() {
  const env = detectEnvironment();
  const result = env === 'app' || env === 'miniprogram';
  console.log(`[Platform] isWebView = ${result} (环境: ${env})`);

  // 🎯 视觉标记：在页面角落显示当前环境（仅开发环境）
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    // 获取 URL 参数
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const hasToken = !!token;

    const tag = document.createElement('div');
    tag.style.cssText = `
      position: fixed;
      bottom: 10px;
      right: 10px;
      background: ${result ? '#ff6b6b' : '#51cf66'};
      color: white;
      padding: 8px 16px;
      font-size: 13px;
      border-radius: 6px;
      z-index: 99999;
      font-weight: bold;
      font-family: monospace;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      opacity: 0.95;
      pointer-events: none;
      line-height: 1.6;
    `;
    tag.innerHTML = `
      📱 ${env.toUpperCase()} | WebView: ${result ? '✅' : '❌'}`;

    if (result) {
      document.body.appendChild(tag);
    }

    // 额外在控制台输出详细信息
    console.log('[Platform] 详细信息:', {
      env,
      isWebView: result,
      hasToken: hasToken,
      token: token ? `${token.substring(0, 10)}...` : null,
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  }

  return result;
}
/**
 * 获取当前环境
 */
export function getEnvironment() {
  return detectEnvironment();
}

/**
 * 获取 token
 */
export function getToken() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || params.get('access_token');
  if (token) {
    localStorage.setItem('token', token);
    return token;
  }
  return localStorage.getItem('token');
}

/**
 * 检查是否已登录
 */
export function isLoggedIn() {
  return !!getToken();
}

/**
 * 登录适配
 */
export function login(redirectUrl) {
  const env = detectEnvironment();
  const currentUrl = redirectUrl || window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);

  switch (env) {
    case 'miniprogram': {
      if (wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/login/login?redirect=${encodedUrl}`,
          fail: () => { window.location.href = `/login?redirect=${encodedUrl}`; },
        });
      }
      break;
    }
    case 'app': {
      if (window.ReactNativeWebView?.navigateToLogin) {
        window.ReactNativeWebView.navigateToLogin({ redirect: currentUrl });
      } else {
        window.location.href = `/login?redirect=${encodedUrl}`;
      }
      break;
    }
    default: {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }
}


/**
 * 跳转支付
 */
export function depositPayment(redirectUrl) {
  const env = detectEnvironment();
  const currentUrl = redirectUrl || window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);

  switch (env) {
    case 'miniprogram': {
      if (wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/payment/payment?redirect=${encodedUrl}`,
          fail: () => { window.location.href = `/login?redirect=${encodedUrl}`; },
        });
      }
      break;
    }
    case 'app': {
      if (window.ReactNativeWebView?.postMessage) {
         window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goDepositPayment',
            data: {
              redirect: currentUrl,
              encodedRedirect: encodedUrl,
            }
          })
        );
      } else {
        //window.location.href = `/login?redirect=${encodedUrl}`;
      }
      break;
    }
    default: {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }
}

/**
 * 办理号牌
 */
export function getPaddle(redirectUrl) {
  const env = detectEnvironment();
  const currentUrl = redirectUrl || window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);

  switch (env) {
    case 'miniprogram': {
      if (wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/payment/payment?redirect=${encodedUrl}`,
          fail: () => { window.location.href = `/login?redirect=${encodedUrl}`; },
        });
      }
      break;
    }
    case 'app': {
      if (window.ReactNativeWebView?.navigateToLogin) {
        window.ReactNativeWebView.navigateToLogin({ redirect: currentUrl });
      } else {
        window.location.href = `/login?redirect=${encodedUrl}`;
      }
      break;
    }
    default: {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }
}


/**
 * 办理号牌签约
 */
export function getSignPaddle(redirectUrl) {
  const env = detectEnvironment();
  const currentUrl = redirectUrl || window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);

  switch (env) {
    case 'miniprogram': {
      if (wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/payment/payment?redirect=${encodedUrl}`,
          fail: () => { window.location.href = `/login?redirect=${encodedUrl}`; },
        });
      }
      break;
    }
    case 'app': {
      console.log(246, redirectUrl)
      window.location.href = currentUrl
      break;
    }
    default: {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }
}


/**
 * 办理号牌签约
 */
export function handleLogout() {
  const env = detectEnvironment();
  const currentUrl =  window.location.href;
  const encodedUrl = encodeURIComponent(currentUrl);

  switch (env) {
    case 'miniprogram': {
      if (wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/login/login?logout=false`,
          fail: () => { },
        });
      }
      break;
    }
    case 'app': {
      if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'logout',
            data: {}
          })
        );
      }
      break;
    }
    default: {
      window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
    }
  }
}


/**
 * 登出
 */
export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  window.location.reload();
}

/**
 * 平台信息对象
 */
export const platform = {
  get env() { return detectEnvironment(); },
  get isApp() { return detectEnvironment() === 'app'; },
  get isMiniprogram() { return detectEnvironment() === 'miniprogram'; },
  get isH5() { return detectEnvironment() === 'h5'; },
  get isWebView() { return isWebView(); },
  get isLoggedIn() { return isLoggedIn(); },
  login,
  logout,
  getToken,
  depositPayment,
  getSignPaddle,
  handleLogout
};